import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { FormMutation } from "../../../../../core/service/types/FormMutation";
import type { FormQuery } from "../../../../../core/service/types/FormQuery";
import type { Dto } from "../../../../../core/types/be/Dto";
import type { CardImplementationEntity } from "../../types/CardImplementationEntity";
import { CardImplementationDtoToEntity } from "../mappers/CardImplementationDtoToEntity";
import { CardImplementationEntityToDto } from "../mappers/CardImplementationEntityToDto";

const CardImplementationApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        CardImplementationLoad: builder.query<CardImplementationEntity, FormQuery>({
            providesTags: [ResourceName.CARD_IMPLEMENTATIONS],
            query: (queryParams) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.CARD_IMPLEMENTATIONS}/${queryParams.entityId}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return CardImplementationDtoToEntity(response);
            },
        }),
        CardImplementationSave: builder.mutation<CardImplementationEntity, FormMutation<CardImplementationEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.CARD_IMPLEMENTATIONS}`;
                const method = "POST";

                const body = CardImplementationEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.CARD_IMPLEMENTATIONS],
        }),
        CardImplementationUpdate: builder.mutation<CardImplementationEntity, FormMutation<CardImplementationEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.CARD_IMPLEMENTATIONS}/${mutation.data.id}`;
                const method = "PUT";

                const body = CardImplementationEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.CARD_IMPLEMENTATIONS],
        }),
    }),
});

export const { useCardImplementationLoadQuery, useCardImplementationSaveMutation, useCardImplementationUpdateMutation } =
    CardImplementationApi;
